import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import Glyph from '../components/Glyph/Glyph.js';

const GlyphRight = ({
  title,
  titleId,
  filled = void 0,
  ...props
}) => /* @__PURE__ */ jsx(Glyph, { ...props, children: /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    "aria-hidden": !title,
    role: title ? "img" : void 0,
    width: "1em",
    height: "1em",
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M11.709 7.294L5.705 1.29a1.002 1.002 0 00-1.413 0 1.001 1.001 0 000 1.413L9.59 8l-5.298 5.296a1.001 1.001 0 000 1.413 1.002 1.002 0 001.413 0l6.004-6.003a1.001 1.001 0 000-1.412z" })
    ]
  }
) });

export { GlyphRight as default };
